// extracted by mini-css-extract-plugin
export default {"button":"styles_button__f7foy","center":"styles_center__x87Jl","reject":"styles_reject__neQKE","black":"styles_black__9Mdh3"};